import axios from 'axios'
import { config } from '../Config/config'


const appointmentService = {

    // getAll: (filter) => {
    //     // getAll: () => {
    //     const result = axios.post(config.apiUrl + '/locationFilter', filter)
    //         .then(respon => {
    //             return {
    //                 success: respon.data.success,
    //                 result: respon.data.result
    //             }
    //         })
    //         .catch(error => {
    //             return {
    //                 success: false,
    //                 error: error
    //             }
    //         })
    //     return result
    // },

    getAllData: () => {
        // getAll: () => {
        const result = axios.get(config.apiUrl + '/appointment')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAllDataJanji: (data) => {
        // getAll: () => {
        const result = axios.post(config.apiUrl + '/pasien_filter_new', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getFaskes: (data) => {
        // getAll: () => {
        const result = axios.post(config.apiUrl + '/faskesJanji', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getFaskesDetail: (data) => {
        // getAll: () => {
        const result = axios.post(config.apiUrl + '/faskesJanjiDetailDoctor', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    // addDataJanji: (data) => {
    //     console.log(data)

    //     const result = axios.post(config.apiUrl + '/janji', data)
    //         .then(respon => {
    //             return {
    //                 success: respon.data.success,
    //                 result: respon.data.result
    //             }
    //         })
    //         .catch(error => {
    //             return {
    //                 success: false,
    //                 error: error
    //             }
    //         })
    //         console.log(result)
    //     return result

    // },`

    addDataJanji: (data) => {
        const result = axios.post(config.apiUrl + '/janji', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    // getTreatmentByFaskesId : (id) => {
    getTreatmentByDoctorOfficeId: (id) => {
        const result = axios.get(config.apiUrl + '/treatmentByDoctorOfficeId/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    cekDayAppointment : (filter) => {
        const result = axios.post(config.apiUrl + '/cekHariRencanaJanji', filter)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    cekRencanaAppoinment : (id) => {
        const result = axios.get(config.apiUrl + '/rencanaKedatanganCek/' + id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    cekJanjiByNamaPasien: (id) => {
        const result = axios.get(config.apiUrl + '/cekJanjiByNamaPasien/'+ id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    cekPasienByJanji: (data) => {
        // const result = axios.get(config.apiUrl + '/cekWilayahByName/'+ data)
        const result = axios.post(config.apiUrl + '/cekPasienByJanji', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },













    // getByFaskesId : (id) => {
    //     const result = axios.get(config.apiUrl + '/treatment_ByFaskesId/' + id)
    //     .then(respon => {
    //         return{
    //             success : respon.data.success,
    //             result : respon.data.result
    //         }
    //     })
    //     .catch(error =>{
    //         return{
    //             success : false,
    //             error : error
    //         }
    //     })
    //     return result
    // },

    // editData: (data) => {
    //     const result = axios.put(config.apiUrl + '/location', data)
    //         .then(respon => {
    //             return {
    //                 success: respon.data.success,
    //                 result: respon.data.result
    //             }
    //         })
    //         .catch(error => {
    //             return {
    //                 success: false,
    //                 error: error
    //             }
    //         })
    //     return result

    // },

    // editDataDelete: (data) => {
    //     const result = axios.put(config.apiUrl + '/locationDelete', data)
    //         .then(respon => {
    //             return {
    //                 success: respon.data.success,
    //                 result: respon.data.result
    //             }
    //         })
    //         .catch(error => {
    //             return {
    //                 success: false,
    //                 error: error
    //             }
    //         })
    //     return result

    // },

    // getById: (id) => {
    //     const result = axios.get(config.apiUrl + '/appointmentById/' + id)
    //         .then(respon => {
    //             return {
    //                 success: respon.data.success,
    //                 result: respon.data.result[0]
    //             }
    //         })
    //         .catch(error => {
    //             return {
    //                 success: false,
    //                 error: error
    //             }
    //         })
    //     return result
    // },

    // getByBiodataParentId: (id) => {
    //     const result = axios.get(config.apiUrl + '/appointmentByBiodataParentId/' + id)

    //         .then(respon => {
    //             return {
    //                 success: respon.data.success,
    //                 result: respon.data.result
    //             }
    //         })
    //         .catch(error => {
    //             return {
    //                 success: false,
    //                 error: error
    //             }
    //         })
    //     return result
    // },

    // deleteData
    // deleteData: (id) => {
    //     const result = axios.delete(config.apiUrl + '/location/' + id)
    //         .then(respon => {
    //             return {
    //                 success: respon.data.success,
    //                 result: respon.data.result
    //             }
    //         })
    //         .catch(error => {
    //             return {
    //                 success: false,
    //                 error: error
    //             }
    //         })
    //     return result
    // },

}

export default appointmentService
